<template>
  <transition name="modal">
    <div class="modal-mask-product">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="form-card__header">
            <h6 class="form-card__title">
              <i class="bi bi-key"></i>
              Cierre de caja
            </h6>
            <button type="button" class="form-card__btn" @click="close()">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>

          <div class="modal-body form-card form-card--bare">
            <div v-if="fund.name" class="form-card__field">
              <label class="form-card__label">Caja</label>
              <div class="data-table__primary">{{ fund.name }}</div>
            </div>

            <div v-if="balance !== null" class="form-card__field">
              <label class="form-card__label">Saldo actual</label>
              <div class="data-table__primary">{{ formattedBalance }}</div>
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="cierre-remainder">Remanente</label>
              <input
                id="cierre-remainder"
                v-model.number="remainder"
                type="number"
                step="0.01"
                class="form-control"
                placeholder="Ingrese el monto..."
              >
              <div class="form-card__hint">El monto que quedará en la caja.</div>
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="cierre-destination">Caja destino del retiro</label>
              <q-select v-model.number="selectedFund" :options="fundOptions" />
            </div>
          </div>

          <div class="form-card__footer">
            <button type="button" class="form-card__btn" @click="close">Cancelar</button>
            <button
              type="button"
              class="form-card__btn form-card__btn--primary"
              :disabled="!canClose || isSubmitting"
              @click="closeFund()"
            >
              <i class="bi bi-key"></i>
              Cerrar caja
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import moment from 'moment';
import 'moment/locale/es';
import formatMoneyMixin from "./../../mixins/formatMoneyMixin";
import QSelect from '@/components/shared/QSelect.vue';

export default {
  props: ['fund_id'],
  components: { QSelect },
  mixins: [formatMoneyMixin],
  data: function () {
    return {
      remainder: null,
      fund: {},
      funds: [],
      selectedFund: 0,
      balance: null,
      isSubmitting: false,
    };
  },
  computed: {
    canClose() {
      return this.balance !== null && this.remainder !== null && this.remainder >= 0;
    },
    fundOptions() {
      return [{ value: 0, label: 'Ninguna (solo retira)' }, ...this.funds.map(f => ({ value: f.id, label: f.name }))];
    },
    formattedBalance() {
      if (this.balance === null) return '';
      return this.fund.currency === 'US$'
        ? this.formatoDinamicoMonedaUSD(this.balance)
        : this.formatoMoneda2Dec(this.balance);
    },
  },
  mounted() {
    this.getTotal();
    this.getFund();
    this.getFunds();
  },
  methods: {
    close() {
      this.$emit('closemodal');
    },
    getTotal() {
      this.$http.get("/api/funds/getBalance/" + this.fund_id).then((response) => {
        this.balance = response.data.data;
      });
    },
    getFund() {
      this.$http.get("/api/funds/getFund/" + this.fund_id).then((response) => {
        this.fund = response.data.data;
      });
    },
    getFunds() {
      this.$http.get("/api/funds/listSimple").then((response) => {
        this.funds = response.data.data
          .filter(f => f.type === 'Efectivo' && f.id != this.fund_id);
      });
    },
    closeFund() {
      if (!this.canClose) return;
      if (!confirm("¿Está seguro que desea cerrar esta caja?")) return;
      this.$emit('load');
      this.isSubmitting = true;
      const amount = this.balance - this.remainder;

      // 1) Egreso del saldo total (cierre)
      const cierreMov = {
        amount: this.balance,
        category_id: 6,
        description: "CIERRE DE CAJA DEL " + moment().format('LL') + ' - Retiro: $' + amount,
        type: "out",
      };

      this.$http.post("/api/funds/movement/" + this.fund_id, cierreMov).then(() => {
        // 2) Ingreso del remanente (apertura)
        const aperturaMov = {
          amount: this.selectedFund === 0 ? this.remainder : this.balance,
          category_id: 5,
          description: "APERTURA DE CAJA",
          type: "in",
        };

        return this.$http.post("/api/funds/movement/" + this.fund_id, aperturaMov);
      }).then(() => {
        // 3) Si hay caja destino y monto a transferir, transferimos el retiro
        if (this.selectedFund !== 0 && amount > 0) {
          return this.$http.post("/api/funds/transfer/" + this.fund_id, {
            to_fund_id: this.selectedFund,
            amount,
          });
        }
        return null;
      }).then(() => {
        this.$emit('closemodal');
        this.$emit('closeDone');
      }).finally(() => {
        this.isSubmitting = false;
      });
    },
  },
};
</script>

<style scoped>
.modal-mask-product {
  position: fixed;
  z-index: 1050;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(16, 24, 40, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: hidden;
}

.modal-dialog {
  margin: 0;
  width: 100%;
  max-width: 560px;
}

.modal-content {
  border: 1px solid var(--border-soft);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.18);
  overflow: hidden;
}

.modal-body {
  max-height: 70vh;
  overflow-y: auto;
  padding: 20px 24px;
}

.modal-enter,
.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-content,
.modal-leave-active .modal-content {
  transform: scale(1.02);
}
</style>
